import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { MessageCircle, X } from "lucide-react";

export const SupportWidget = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const seen = sessionStorage.getItem("pt_support_prompt");
    if (!seen) {
      const t = setTimeout(() => {
        setOpen(true);
        sessionStorage.setItem("pt_support_prompt", "1");
      }, 6000);
      return () => clearTimeout(t);
    }
  }, []);

  return (
    <div className="fixed bottom-6 right-6 z-[80] flex flex-col items-end gap-3">
      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="support-prompt"
            initial={{ opacity: 0, y: 16, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 16, scale: 0.95 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="relative w-72 rounded-2xl bg-[#121118] border border-white/15 shadow-[0_20px_50px_rgba(0,0,0,0.6)] p-5"
          >
            <button
              onClick={() => setOpen(false)}
              data-testid="support-prompt-close"
              className="absolute top-3 right-3 text-white/40 hover:text-white transition-colors"
            >
              <X size={16} />
            </button>
            <p className="font-future text-sm text-white">Need a hand? 👋</p>
            <p className="text-sm text-white/60 mt-2 leading-relaxed">
              Questions about the guides, pricing or a refund? Chat with Aria — our support assistant.
            </p>
            <button
              data-testid="support-prompt-open"
              onClick={() => navigate("/support")}
              className="mt-4 w-full label-caps px-4 py-3 rounded-full bg-[var(--neon-cyan)] text-black hover:bg-white transition-colors duration-300"
            >
              Get support
            </button>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.button
        data-testid="support-bubble"
        whileHover={{ scale: 1.06 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => (open ? navigate("/support") : setOpen(true))}
        className="w-14 h-14 rounded-full bg-[var(--neon-cyan)] text-black flex items-center justify-center shadow-[0_10px_30px_rgba(0,240,255,0.35)]"
        aria-label="Open support"
      >
        <MessageCircle size={22} />
      </motion.button>
    </div>
  );
};
